/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Update_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to update speaker" |
*
* @param {Speaker_Manager_Update_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_update_failed_toast = /** @type {((inputs?: Speaker_Manager_Update_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Update_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de la mise a jour du locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecheraktualisierung fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiornare l'altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось обновить информацию о динамике.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo actualizar el altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扬声器更新失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの更新に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर को अपडेट करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao atualizar o alto-falante")
	return /** @type {LocalizedString} */ ("Failed to update speaker")
});